import React, { useEffect, useState } from 'react'
import _axios from '../../utils/api/_axios'
import { baseUrl } from '../../common/constants'
import { toast } from 'react-toastify'
import styles from './profile.module.scss'

function Profile() {
    const [profileData, setProfileData] = useState(null);
    const [authKey,setAuthKey] = useState(null);
    const [copyStatus, setCopyStatus] = useState('');

    async function fetchProfile() {
        try {
            const token = localStorage.getItem('token');
            const response = await _axios.get(`${baseUrl}/profile`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.data) {
                setProfileData(response);
            }
        } catch (error) {
            toast.error('Failed to fetch profile data');
        }
    }

    useEffect(() => {
        fetchProfile();
    }, []);

    async function keyGeneration() {
      const token = localStorage.getItem("token");
      const obj  = {
        email : profileData?.data?.response?.payload?.personal?.email,
        token: token
      } 
        try {
            const response = await _axios.post(`${baseUrl}/authentication/twoFactor/generateKey`,obj,
            {
              headers:{
                'Content-Type': 'application/json'
              }
            });
            setAuthKey(response);
        } catch (error) {
            toast.error('Failed to generate 2FA key');
        }
    }
    
    const handleCopy = () => {
        const key = authKey?.data?.payload?.secret?.base32;
        if (key) {
          navigator.clipboard.writeText(key);
          setCopyStatus('Key copied to clipboard!');
          setTimeout(() => setCopyStatus(''), 3000); // Clear message after 3 seconds
        }
      };
    
    return (
        <div className={styles.profileContainer}>
            <h2 className={styles.profileTitle}>User Profile</h2>
            <div className={styles.profileCard}>
                <div className={styles.profileInfo}>
                    {profileData ? (
                        <>
                            <p className={styles.infoItem}>
                                <span className={styles.label}>Name:</span> 
                                {`${profileData?.data?.response?.payload?.personal?.firstName} ${profileData.data.response.payload.personal.lastName}` || 'N/A'}
                            </p>
                            <p className={styles.infoItem}>
                                <span className={styles.label}>Email:</span>
                                {profileData?.data?.response?.payload?.personal?.email || 'N/A'}
                            </p>
                            <p className={styles.infoItem}>
                                <span className={styles.label}>Phone:</span>
                                {profileData?.data?.response?.payload?.personal?.phoneNumber || 'N/A'}
                            </p>
                        </>
                    ) : (
                        <p>Loading profile data...</p>
                    )}
                </div>
                { profileData?.data?.response?.payload?.personal?.isTwoFactorAuth 
                  ?
                  <div style={{width:'100%'}}>
                    <button className={styles.enabled2faBtn}>2FA is enabled</button>
                    <div style={{marginTop:'20px'}}>This is your auth key - </div>
                    <div
                        style={{
                            marginTop: '10px',
                            fontSize: '12px',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: '#f9f9f9',
                            color: '#333',
                            wordWrap: 'break-word',
                        }}
                    >
                            {profileData?.data?.response?.payload?.personal?.twoFactorAuthKey || 'Key not available'}
                    </div>
                  </div>
                  :
                  <button className={styles.enable2faBtn} onClick={keyGeneration}>Enable 2FA</button>
                }
          <div className={styles.authContainer}>
            {authKey && (
              <div className={styles.authCard}>
                <h2 className={styles.title}>Enable 2-Factor Authentication (2FA)</h2>
                <p className={styles.instructions}>
                  To enable 2FA, follow these steps:
                </p>
                <ol className={styles.steps}>
                  <li>Download and install the <strong>Google Authenticator</strong> app on your mobile device.</li>
                  <li>
                    Use the app to <strong>scan the QR code</strong> below or manually enter the key provided.
                  </li>
                  <li>Complete the setup in the app and verify the code.</li>
                </ol>
                <p className={styles.secretKey}>
                  <span className={styles.label}>Secret Auth Key:</span> {authKey?.data?.payload?.secret}
                  <button onClick={handleCopy} className={styles.copyButton}>Copy</button>
                </p>
                {copyStatus && <p className={styles.copyStatus}>{copyStatus}</p>}
                <div className={styles.qrCodeContainer}>
                  <img
                    src={authKey?.data?.payload?.imageData}
                    alt="QR Code"
                    className={styles.qrCodeImage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
    </div>
    )
}

export default Profile